var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubscription = function SvgSubscription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B8B8FF",
    clipPath: "url(#subscription_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 1h1a2 2 0 0 1 2 2v1.603A7 7 0 0 0 12 4V3H5a1 1 0 0 1-2 0H2v2h5.392a7 7 0 0 0-2.137 2H2v5h2v2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1a1 1 0 0 1 2 0h4a1 1 0 0 1 2 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.998 8.069V10l3-3-3-3V5.97l-.197.035c-.151.025-.302.05-.444.1-2.602.931-3.992 3.903-3.07 6.532.921 2.629 3.778 4.005 6.38 3.075 2.602-.931 3.965-3.817 3.043-6.446a.997.997 0 0 0-1.276-.615c-.52.186-.793.763-.608 1.29.553 1.577-.265 3.308-1.826 3.867a2.99 2.99 0 0 1-3.829-1.845c-.548-1.564.29-3.32 1.827-3.893"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "subscription_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSubscription;